module.exports = __webpack_public_path__ + "img/H5_10.4d279496.png";